import React from "react";

interface LampIconProps {
  active: boolean;
}

export default function LampIcon({ active }: LampIconProps) {
  const stroke = active ? "#1976d2" : "#9ca3af";
  const fill = active ? "#dbeafe" : "#f3f4f6";
  const border = active ? "#1976d2" : "#d1d5db";

  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="28" y1="48" x2="28" y2="26" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
      <path
        d="M28 26 Q14 26 14 16 Q14 8 28 8 Q42 8 42 16 Q42 26 28 26Z"
        fill={fill}
        stroke={border}
        strokeWidth="1.5"
      />
      <circle cx="20" cy="27" r="4" fill={fill} stroke={border} strokeWidth="1.5" />
      <circle cx="36" cy="27" r="4" fill={fill} stroke={border} strokeWidth="1.5" />
      <line x1="24" y1="48" x2="32" y2="48" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
